import samtykkeReducer, { defaultState, type SamtykkeState, type Samtykke } from "./samtykkeReducer";

export { defaultState, type SamtykkeState, type Samtykke };
export default samtykkeReducer;
